console.log(` _____        __                         
/__  /  ___  / /_  _________ _      _____
  / /  / _ \\/ __ \\/ ___/ __ \`/_____/ ___/
 / /__/  __/ /_/ / /  / /_/ /_____/ /__  
/____/\\___/_.___/_/   \\__,_/      \\___/`)